import React, { useContext } from "react";
import { ApplicationContext } from "@context/ApplicationContext";
import { AuthContext } from "@context/AuthContext";
import CandyBarIcon from "@components/Icons/CandyBarIcon/index.js";
import TicketIcon from "@components/Icons/TicketIcon/index.js";
import "./style.scss";

const VoucherConfirmation = ({ purchasedVoucher }) => {
    const { user }       = useContext(AuthContext);
    const { whiteLabel } = useContext(ApplicationContext);

    const tickets   = purchasedVoucher?.tickets   ?? [];
    const candyBars = purchasedVoucher?.candyBars ?? [];
    const hasVouchers = tickets.length > 0 || candyBars.length > 0;

    return (
        <div className="voucher-confirmation">
            <div className="voucher-confirmation__header">
                <p className="paragraph">
                    Hi{user?.first_name ? ` ${user.first_name}` : ""},<br />
                    Thanks for your movie voucher purchase.
                </p>
            </div>

            <div className="voucher-confirmation__content">
                {hasVouchers ? (
                    <>
                        <p className="paragraph">Please find your vouchers below:</p>

                        {tickets.length > 0 && (
                            <ul className="voucher-confirmation__list">
                                {tickets.map((url, i) => (
                                    <li key={`ticket-${i}`} className="voucher-confirmation__item">
                                        <a
                                            href={url}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="button button__primary voucher-confirmation__button"
                                        >
                                            <TicketIcon className="button__icon" />
                                            Download Voucher {i + 1}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        )}

                        {candyBars.length > 0 && (
                            <>
                                <p className="paragraph">Please find your candybar vouchers below:</p>
                                <ul className="voucher-confirmation__list">
                                    {candyBars.map((url, i) => (
                                        <li key={`candy-${i}`} className="voucher-confirmation__item">
                                            <a
                                                href={url}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="button button__primary voucher-confirmation__button"
                                            >
                                                <CandyBarIcon className="button__icon" />
                                                Download Voucher {i + 1}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}
                    </>
                ) : (
                    <p className="paragraph">
                        Your voucher details are being processed. Please check your email shortly.
                    </p>
                )}

                <p className="paragraph">
                    Present your downloaded voucher (printed or on your mobile device) to box
                    office staff. They&#39;ll exchange the voucher for a ticket and in you go.
                </p>
                <p className="paragraph">
                    Please refer to the cinema&#39;s website to book a session using a voucher,
                    and refer to the voucher for full terms and conditions.
                </p>
                <p className="paragraph">
                    Thanks,<br />
                    {whiteLabel?.brand_name}
                </p>
            </div>
        </div>
    );
};

export default VoucherConfirmation;
